module.exports = __webpack_public_path__ + "static/media/uci.daba767f.png";